import { render, staticRenderFns } from "./SdFile.vue?vue&type=template&id=3f832fcb&scoped=true"
import script from "./SdFile.vue?vue&type=script&lang=js"
export * from "./SdFile.vue?vue&type=script&lang=js"
import style0 from "./SdFile.vue?vue&type=style&index=0&id=3f832fcb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f832fcb",
  null
  
)

export default component.exports